import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import {
  ExternalIntegrationLog,
  ExternalIntegrationLogSchema,
} from 'dashboard/models/external-integration-log';
import { dashboardApi } from 'dashboard/redux/api/api';
import { ApiOptions } from 'lib/clients/ApiClient';
import {
  ApiEndpoint,
  ApiListResponse,
  ApiModel,
  ApiResponse,
  PaginationParams,
} from 'lib/interfaces/api';

const api = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    listExternalIntegrationLogs: builder.query<
      ApiListResponse<ExternalIntegrationLog, PaginationParams>,
      ApiOptions
    >({
      query: async (options) =>
        await SessionClientDashboard.listResource<ExternalIntegrationLog, PaginationParams>(
          ApiEndpoint.ExternalIntegrationLog,
          options,
        ),
      providesTags: () => [{ type: ApiModel.ExternalIntegrationLog, id: 'LIST' }],
    }),
    getExternalIntegrationLog: builder.query<
      ApiResponse<ExternalIntegrationLog, ExternalIntegrationLogSchema>,
      string
    >({
      query: async (integrationLogId) =>
        await SessionClientDashboard.getResource<
          ExternalIntegrationLog,
          ExternalIntegrationLogSchema
        >(ApiEndpoint.ExternalIntegrationLog, integrationLogId),
      providesTags: (result, _error, _id) =>
        result ? [{ type: ApiModel.ExternalIntegrationLog, id: result.data.id }] : [],
    }),
  }),
});

export const {
  useListExternalIntegrationLogsQuery,
  useLazyListExternalIntegrationLogsQuery,
  useGetExternalIntegrationLogQuery,
} = api;
